import { lazy, Suspense } from 'react';
import { WidgetElement } from '../../../modules/layout/types/widgetElement';
import { cssWhen } from '../../utils/themeUtils';
import { NbLoader } from '../loader/Loader';
import { ChartModalProps } from './ChartModal';
import classes from './LazyChart.module.scss';

export type LazyChartProps = {
  type: 'page' | 'modal' | 'widget';
  props?: WidgetElement | ChartModalProps;
};

const ChartWrapperLazy = lazy(() => import('./ChartWrapper'));

export const LazyChart = (props: LazyChartProps) => {
  return (
    <Suspense
      fallback={
        <div className={cssWhen([props.type === 'modal', classes.lazyChartIsModal])}>
          <NbLoader
            horizontalCenter
            verticalCenter
          />
        </div>
      }
    >
      <ChartWrapperLazy {...props} />
    </Suspense>
  );
};
